var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTelegramSocial = function SvgTelegramSocial(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FF8686"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9867 27.7113L19.5235 34.226C20.1862 34.226 20.4732 33.9413 20.8174 33.5995L23.9242 30.6303L30.3619 35.3448C31.5425 36.0028 32.3744 35.6563 32.6929 34.2586L36.9185 14.458L36.9197 14.4568C37.2942 12.7115 36.2885 12.029 35.1382 12.4571L10.2999 21.9666C8.60471 22.6246 8.63037 23.5696 10.0117 23.9978L16.3619 25.973L31.112 16.7435C31.8062 16.2838 32.4374 16.5381 31.9182 16.9978L19.9867 27.7113Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegramSocial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/7391d7c9fbf7052b9b7654cadec9403c.telegram-social.7391d7c9fbf7052b9b7654cadec9403c.svg";
export { ForwardRef as ReactComponent };